module.exports = __webpack_public_path__ + "static/media/work-with-us_water.ed274c8d.jpg";